import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ProgramArticleService } from "../../services/program-article.service";
import {
  ProgramArticlesActions,
  ProgramArticlesStateInterface,
} from "../../store/actions/program-articles.actions";
import { MD_DIALOG_DATA, MdDialog } from "@angular/material";
import { ObjectToArrayPipe } from "../../pipes/object-to-array.pipe";
import { Language } from "../../models/language";
import { Store } from "@ngrx/store";
import { ProgramArticle } from "../../models/program-article";
import {
  TranslationListByField,
  ProgramArticlePictureETTValue,
  ProgramArticleTranslationETTValue,
} from "../../models/program-article-translation-value";
import { Subscription } from "rxjs/Subscription";
import * as _ from "lodash";
import { EventArticleService } from "../../services/event-article.service";

@Component({
  selector: "app-multilingual-modal",
  templateUrl: "./multilingual-modal.component.html",
  styleUrls: ["./multilingual-modal.component.scss"],
})
export class MultilingualModalComponent implements OnInit, OnDestroy {
  translations: TranslationListByField[];
  translationClicked: any;
  pictureClicked: ProgramArticlePictureETTValue;
  partials: any[];
  partialsPicture: any[];
  partialsPictureInitial: any[];
  loading: boolean;
  programArticle: ProgramArticle;
  subscriptions: Subscription[];
  pictures: ProgramArticlePictureETTValue[];
  picturesInitial: ProgramArticlePictureETTValue[];
  applyPending: boolean;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    private mdDialog: MdDialog,
    private store: Store<any>,
    private programArticleService: ProgramArticleService,
    private eventArticleService: EventArticleService,
    private objectToArrayPipe: ObjectToArrayPipe,
    private programArticlesActions: ProgramArticlesActions
  ) {
    this.loading = true;
    this.applyPending = false;
    this.subscriptions = [];
    this.partialsPicture = [];
    this.partialsPictureInitial = [];
  }

  ngOnInit() {
    // multilingual event article
    if (this.data.sportingEventId) {
      this.translations = [];
      this.GetPicturesForEventArticle();
    } else {
      this.subscriptions.push(
        this.store
          .select("programArticlesState")
          .subscribe((programArticleState: ProgramArticlesStateInterface) => {
            this.loading = true;
            if (
              this.programArticle == null &&
              programArticleState.currentProgramArticle &&
              programArticleState.currentProgramArticle.valEmiId ==
                this.data.valEmiId
            ) {
              this.programArticle = Object.assign(
                {},
                programArticleState.currentProgramArticle
              );
              this.getTranslationsAndPictures();
            } else {
              this.mdDialog.closeAll();
            }
          })
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  getTranslationsAndPictures() {
    this.translations = [];
    this.programArticleService
      .getMultilingual(
        this.data.valEmiId,
        this.data.destination,
        this.data.channelId
      )
      .subscribe((multilingualData) => {
        // First, insert in list all translations already got from Program Article OR previous applied multilingual changes
        // in ProgramArticleState
        this.programArticle.destinations
          .find((d) => d.id === this.data.destination)
          .value.translations.forEach((translation) => {
            if (
              !this.translations.find((t) => {
                return t.fieldName === translation.name;
              })
            ) {
              this.translations.push(
                new TranslationListByField({
                  fieldName: translation.name,
                  inputType: translation.inputType,
                  translations: [_.cloneDeep(translation)],
                })
              );
            } else {
              let fieldTranslations = this.translations.find(
                (t) => t.fieldName == translation.name
              ).translations;
              if (
                !fieldTranslations.find(
                  (t) => t.language.id == translation.language.id
                )
              ) {
                this.translations
                  .find((t) => t.fieldName == translation.name)
                  .translations.push(translation);
              }
            }
          });

        if (multilingualData) {
          // Then, insert in list all translations from Multilingual search where the FieldName/Language have not been already inserted in list
          multilingualData.translations.forEach((rawTranslation) => {
            // Check if field name exists. if not, add it
            if (
              !this.translations.find((t) => {
                return t.fieldName === rawTranslation.fieldName;
              })
            ) {
              this.translations.push(
                new TranslationListByField({
                  fieldName: rawTranslation.fieldName,
                  inputType: rawTranslation.inputType,
                  translations: [],
                })
              );
            }
            let fieldTranslations = this.translations.find(
              (t) => t.fieldName == rawTranslation.fieldName
            ).translations;
            if (
              !fieldTranslations.find(
                (t) => t.language.id == rawTranslation.language.id
              )
            ) {
              this.translations
                .find((t) => t.fieldName == rawTranslation.fieldName)
                .translations.push(rawTranslation);
            }
          });
          this.generateTranslationsArray();

          //Then, setting pictures
          this.setPictures(multilingualData.pictures);
        }
        this.loading = false;
      });
  }

  GetPicturesForEventArticle() {
    this.pictures = [];
    this.eventArticleService
      .GetPictures(this.data.sportingEventId)
      .subscribe((multilingualData) => {
        this.setPictures(multilingualData);
        this.loading = false;
      });
  }

  generateTranslationsArray() {
    this.partials = [];
    this.objectToArrayPipe.transform(this.translations).forEach((item) => {
      this.partials[item.fieldName] = this.getTranslationByDisplayName(
        item.translations
      );
    });
  }

  getTranslationByDisplayName(
    rawTranslations: ProgramArticleTranslationETTValue[]
  ) {
    const translations = [];
    rawTranslations.forEach((translation) => {
      translations.push(
        new Object({
          value: translation.content,
          display: translation.content,
          language: translation.language.value,
          selectable: false,
          selected: false,
          source: false,
          locked: translation.isLocked,
          displayLocked: translation.isLocked,
        })
      );
    });
    return translations;
  }

  duplicate(key: string, language: Language) {
    this.translationClicked = this.partials[key].find(
      (translation) => translation.language == language
    );
    this.translationClicked.source = true;
    this.translationClicked.displayLocked = true;
    this.partials[key]
      .filter((translation) => translation.language !== language)
      .map((translation) => {
        translation.selectable = true;
        translation.selected = true;
        translation.display = this.translationClicked.display;
        translation.checked = true;
        translation.displayLocked = true;
      });
    this.applyPending = true;
  }

  duplicateToEmpty(key: string, language: Language) {
    this.translationClicked = this.partials[key].find(
      (translation) => translation.language == language
    );
    this.translationClicked.source = true;
    this.translationClicked.displayLocked = true;
    this.partials[key]
      .filter(
        (translation) =>
          translation.language !== language && translation.display === ""
      )
      .map((translation) => {
        translation.selectable = true;
        translation.selected = true;
        translation.display = this.translationClicked.display;
        translation.checked = true;
        translation.displayLocked = true;
      });
    this.applyPending = true;
  }

  copyText(key: string, language: Language) {
    this.translationClicked = this.partials[key].find(
      (translation) => translation.language == language
    );
    this.translationClicked.source = true;
    this.translationClicked.displayLocked = true;
    this.partials[key]
      .filter((translation) => translation.language !== language)
      .map((translation) => {
        translation.selectable = true;
        translation.selected = false;
        translation.checked = false;
        translation.displayLocked = false;
      });
    this.applyPending = true;
  }

  applyDuplicate(key: string) {
    this.partials[key].map((translation) => {
      if (translation.checked || translation.source) {
        translation.value = translation.display;
        translation.displayLocked = true;
        translation.locked = true;
      }
      translation.selectable = false;
      translation.selected = false;
      translation.source = false;
      return translation;
    });
    this.synchronizePartials(key);
    this.applyPending = false;
  }

  synchronizePartials(key: string) {
    this.translations
      .find((t) => t.fieldName === key)
      .translations.map((translation) => {
        const partial = this.partials[key].find(
          (p) => p.language === translation.language.value
        );
        translation.content = partial.value;
        translation.isLocked = partial.locked;
      });
  }

  cancelDuplicate(key: string) {
    this.partials[key].map((translation) => {
      translation.selectable = false;
      translation.selected = false;
      translation.source = false;
      translation.displayLocked = translation.locked;
      translation.display = translation.value;
    });
    this.applyPending = false;
  }

  recheckDuplicate(translation: any, event: any) {
    if (event.checked) {
      translation.display = this.translationClicked.value;
      translation.displayLocked = true;
    } else {
      translation.display = translation.value;
      translation.displayLocked = translation.locked;
    }
  }

  valueChanged(translation, key) {
    translation.value = translation.display;
    translation.displayLocked = true;
    translation.locked = true;
    this.synchronizePartials(key);
  }

  toggleLockTranslation(translation, key, value: boolean) {
    translation.locked = value;
    translation.displayLocked = value;
    this.synchronizePartials(key);
  }

  // /!\ picture here contains all format for one language
  setPictures(rawPictures: ProgramArticlePictureETTValue[]) {
    this.pictures = [];
    if (!this.data.sportingEventId) {
      // first, insert already updated pictures (from previous multilingual edition)
      this.programArticle.destinations
        .find((d) => d.id === this.data.destination)
        .value.pictures.forEach((picture) => {
          if (
            !this.partialsPicture.find(
              (p) => p.language.id === picture.language.id
            )
          ) {
            this.partialsPicture.push({
              pictures: [],
              language: picture.language,
              displayLocked: picture.isLocked,
            });
          }
          this.partialsPicture
            .find((pp) => pp.language.value === picture.language.value)
            .pictures.push(picture);
        });
    }

    // then, insert picture for database IF not already updated
    rawPictures.forEach((rawPicture) => {
      // first, check if language has already been inserted
      // if not, insert new picture
      if (
        !this.partialsPicture.find(
          (p) => p.language.id === rawPicture.language.id
        )
      ) {
        this.partialsPicture.push({
          pictures: [],
          language: rawPicture.language,
          displayLocked: rawPicture.isLocked,
        });
      }
      this.partialsPicture
        .find((pp) => pp.language.value === rawPicture.language.value)
        .pictures.push(rawPicture);
    });
    this.partialsPictureInitial = _.cloneDeep(this.partialsPicture);
  }

  toggleLockPicture(picture, value) {
    picture.isLocked = value;
    picture.displayLocked = value;
  }

  apply() {
    if (!this.data.sportingEventId) {
      // Apply translations for each field
      this.translations.forEach((t) => {
        this.programArticlesActions.setMultilingualTranslations(
          t.translations,
          this.data.destination
        );
      });

      // apply pictures
      this.partialsPicture.forEach((pp) => {
        this.programArticlesActions.setMultilingualPictures(
          pp.pictures,
          this.data.destination
        );
      });
    } else {
      // update picture for event article
      let body = [];
      this.partialsPicture.forEach((pp) => {
        body.push({
          sportingEventId: this.data.sportingEventId,
          languageId: pp.language.id,
          pictures: pp.pictures,
        });
      });
      this.eventArticleService.PostPictures(body).subscribe(() => {});
    }

    this.mdDialog.closeAll();
  }

  applyDuplicatePicture() {
    this.partialsPicture.map((p) => {
      p.selectable = false;
      p.selected = false;
      p.checked = false;
      p.source = false;
      p.isLocked = p.displayLocked;
    });
    this.partialsPictureInitial = _.cloneDeep(this.partialsPicture);
    this.applyPending = false;
  }

  cancelDuplicatePicture() {
    this.partialsPicture = _.cloneDeep(this.partialsPictureInitial);

    this.partialsPicture.map((p) => {
      p.selectable = false;
      p.selected = false;
      p.checked = false;
      p.source = false;
      p.displayLocked = p.isLocked;
      this.resetDisplayUrl(p);
    });
    this.applyPending = false;
  }

  duplicatePicture(picture: any) {
    this.pictureClicked = picture;
    picture.displayLocked = true;
    picture.source = true;
    this.partialsPicture
      .filter((p) => p.language.id !== picture.language.id)
      .map((p) => {
        p.selectable = true;
        p.selected = true;
        p.checked = true;
        p.displayLocked = true;
        this.changeDisplayingPictures(picture, p);
      });
    this.applyPending = true;
  }

  duplicateEmptyPicture(picture: any) {
    this.pictureClicked = picture;
    picture.displayLocked = true;
    picture.source = true;
    this.partialsPicture
      .filter(
        (p) => p.language.id !== picture.language.id && p.pictures.length <= 1
      )
      .map((p) => {
        p.selectable = true;
        p.selected = true;
        p.checked = true;
        p.displayLocked = true;
        this.changeDisplayingPictures(picture, p);
      });
    this.applyPending = true;
  }

  copyPicture(picture: any) {
    this.pictureClicked = picture;
    picture.displayLocked = true;
    picture.source = true;
    this.partialsPicture
      .filter((p) => p.language.id !== picture.language.id)
      .map((p) => {
        p.selectable = true;
        p.selected = false;
        p.checked = false;
        p.displayLocked = false;
      });
    this.applyPending = true;
  }

  changeDisplayingPictures(picturesSource: any, picture: any) {

    picturesSource.pictures
    .filter((pictureSource) => pictureSource.pictureSetId === 0)
    .forEach((pictureSource) => {
      picture.duplicatedFromLanguage = pictureSource.language;
      // add if not exists, else modify it
      if (
        !picture.pictures.find(
          (p) => p.pictureFormatCode === pictureSource.pictureFormatCode
        )
      ) {
        // change pictureSource language
        let pictureToCopy = _.cloneDeep(pictureSource);
        pictureToCopy.language = picture.language;
        picture.pictures.push(pictureToCopy);
      } else {
        if (pictureSource.blob) {
          picture.pictures.find(
            (p) => p.pictureFormatCode === pictureSource.pictureFormatCode
          ).blob = pictureSource.blob;
        } else {
          picture.pictures.find(
            (p) => p.pictureFormatCode === pictureSource.pictureFormatCode
          ).pictureURL = pictureSource.pictureURL;
        }

        picture.pictures.find(
          (p) => p.pictureFormatCode === pictureSource.pictureFormatCode
        ).pictureId = pictureSource.pictureId;

        picture.pictures.find(
          (p) => p.pictureFormatCode === pictureSource.pictureFormatCode
        ).isLocked = pictureSource.isLocked;
      }
    });
  }

  checkDuplicatePicture(picture, event) {
    if (event.checked) {
      picture.displayLocked = true;
      this.changeDisplayingPictures(this.pictureClicked, picture);
    } else {
      this.resetDisplayUrl(
        this.partialsPicture.find((p) => p.language.id === picture.language.id)
      );
    }
  }

  resetDisplayUrl(picture) {
    picture.duplicatedFromLanguage = null;
    picture.isLocked = false;
    picture.displayLocked = false;
    let initialPictures = _.cloneDeep(
      this.partialsPictureInitial.find(
        (pi) => pi.language.value === picture.language.value
      ).pictures
    );
    picture.pictures = initialPictures;
  }

  cancel() {
    this.cancelDuplicatePicture();
    this.mdDialog.closeAll();
  }

  getETTPictureByFormat(picture: any, format: string) {
    if (picture.pictures.find((p) => p.pictureFormatName === format)) {
      return picture.pictures.find((p) => p.pictureFormatName === format);
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/multilingual-modal/multilingual-modal.component.ts